import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=0b541e46&scoped=true&"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=0b541e46&prod&scoped=true&lang=css&"
import style1 from "./BaseCheckbox.vue?vue&type=style&index=1&id=0b541e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b541e46",
  null
  
)

export default component.exports